import type { Products } from "../types"

export const products: Products = new Map([
  [
    "mev-capital-bob",
    {
      name: "MEV Capital BNB Cluster",
      description:
        "The MEV Capital BNB Cluster provides a set of liquid collateral markets with an optimized risk-adjusted return.",
      entity: "mev-capital",
      vaults: [
        "0x107a441C473517a37b03dcd8024C5B63E3Cc13DF",
        "0x7593931d08e3BAA750cA3cB6A0d0fDe6acD65107",
        "0x216f6D6C2ca15f83B656f3E9a8FcDf615DBC1710",
        "0xe54DFfd36177975938A3873e522dEE535ADebe01",
        "0x0dD93eb321A768A274d21062067B52527aBd4506",
        "0xD98125a23fAeb48180e33cA6Eef8F128E07418d1",
        "0x777C95b204E2Ed3906885eF09f4531882587B52C",
        "0xd6F4Ee21c946071Cf13D773E2ab1e31d44a27a54",
        "0x088241d1C5c951C59Fb66083b291b69E3cC27E8C",
      ],
    },
  ],
  [
    "apostro-bsc",
    {
      name: "Apostro BSC",
      description:
        "Money market on Binance Smart Chain (BSC), governed by Apostro, enabling seamless access to blue-chip assets with advanced trading strategies like leverage and carry trades.",
      entity: "apostro",
      vaults: [
        "0xC6767dd1fFaA730f6fc90b353d5928E6e9d55C1b",
        "0xa6282FfCDBC1d23dDAd65e97B9d033C4517Ec05E",
        "0x6078b5dE9d10587cb466ECbBF55C95898AFe99C2",
        "0xc27d44A8aEA0CDa482600136c0d0876e807f6C1a",
        "0xC0C13008711cE250699E3A94dCEED5EFd4e8e02a",
        "0x36AEb594689205878E1B57bFc011e0956D82ed08",
        "0x9AE0Da6ACc874119470b52f4f5647B74D042b18B",
        "0xeEC4561f621C3629F2b36a07B207A7E06377e0D5",
        "0x19C1d7E5a2b821D4e05fd9cFB8ba372C2cAA551B",
        "0x3135551ce7945c03C18df7985E089DDBC763cEE8",
      ],
    },
  ],
  [
    "tulipa-bsc",
    {
      name: "Tulipa",
      description:
        "A market tailored to lending and borrowing assets on the BSC chain. Governed by Tulipa.",
      entity: "tulipa-capital",
      vaults: [
        "0x5fd02479F938929F6b9fE1b7Af6430cfD4afa6Aa",
        "0xA9cA5c4bfF689afcFB249AE81565422fa78F82b4",
        "0xEcD1F58B9DC4bbC3A32409961B8520B0A8fcd483",
        "0x932FE4797d681a7a82262BC385B534ba069249E1",
        "0xa6439FD63C19Cc4893EAcaD20320D11cfd0Ad12C",
        "0xfd30377A3173f709d8224Fee7718E312A0868A34",
        "0xc33c2A5f3c27bcB5559f17ff97A04F281f898f04",
      ],
    },
  ],
  [
    "k3-bsc-stable",
    {
      name: "K3 Stablecoin Cluster",
      entity: "k3-capital",
      vaults: [
        "0xca522ECab584b5430ADb946edEE4224A63628362",
        "0x8CE379f1e092f0afCef665529F0d86acf92E8Cd4",
        "0x1E55a40c9C7ca76a8671D8366bEC8c5f8754a336",
        "0x07167e620612069830fdB5289406bB7A1Ddf781c",
        "0x88A81184243c561026973d25384651E6cc0796A4",
        "0x10888BD509aC3e1f423D171008288462988827d5",
        "0x9D30f4226D9aBE940F05acAfD456153BD49ba6D9",
        "0x470379C4416300068E9Afb938b7A0cfF7735d42f",
      ],
    },
  ],
  [
    "k3-bsc-yield",
    {
      name: "K3 BNB Yield Hub",
      entity: "k3-capital",
      vaults: [
        "0x8E01DB38a409D6E6B8A81fd21d84E05912e8730A",
        "0x554a419891bD825e47bC132011821dE1070c35C0",
        "0xA3031755F95E57E1AC9Bb01dBfEb135d40b6DA96",
        "0x78F5d9909163695dfB064d55A222E398918e00a3",
      ],
    },
  ],
  [
    "re7-labs-bsc",
    {
      name: "Re7 Labs Cluster",
      entity: "re7-labs",
      vaults: [
        "0xF72aB1726e6f379891dDAE8114C75074d972FdAc",
        "0xcCD520c8cE2aC576429bE0aD8cc14cDc0e3E44fc",
      ],
      deprecatedVaults: [
        "0x69A93DbAB609266af96f05658b2e22d020de2E19",
        "0xc4dB46B082B415c16C54c91c5750Df8e2f90EF36",
        "0xC41f2Ba7102e9F9F2d603eb951F955aE205ed272",
        "0x5d3b4bcff6a24A20a98070263D03D474586c9b29",
        "0xA00C61ad8c560163c3Ee798a5eAA63EF81BA41e0",
        "0x7a455f66FD2D2d5C69ae403a971ED513C852F9D7",
        "0x266D3F3219680624DE4D66c716444512A2B9a72F",
        "0xa0b6d76452B1f417a94Ae309b835D523a081FbB9",
        "0x3ac88AfbC38Bb41443457eeB027b60e85B815538",
        "0xCB9c9FE7d1509955d8b860E6831d91bf3F0B6240",
        "0xfEb1D6259De6C052A0d0f986b4Df4D8Fd8B371F4",
      ],
    },
  ],
  [
    "k3-bsc-aster",
    {
      name: "K3 Capital ASTERLIQUID",
      entity: "k3-capital",
      vaults: [
        "0x93d31b79502265FEBA5ED18e3cAc9ef795a3b0B1",
        "0x95C5Fd8618C68D6156A739C1EAb5aA7c807ff148",
      ],
    },
  ],
])
